(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dossier-customers-reviews"] && !Shopify.designMode) return;
  try {
    
  const productMainReviewsSlider = document.querySelector('.dossier-customers-reviews__slider');
  new BlazeSlider(productMainReviewsSlider, {
    all: {
      slidesToShow: 1,
      loop: false,
    },
    '(min-width: 768px)': {
      slidesToShow: 2,
      slideGap: '14px',
    },
    '(min-width: 991px)': {
      slidesToShow: 3,
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dossier-product-main-reviews"]) return;
  try {
    
  const productMainReviewsSlider = document.querySelector('.product-main-reviews__slider');
  new BlazeSlider(productMainReviewsSlider, {
    all: {
      slidesToShow: 1,
      loop: false,
    },
    '(min-width: 768px)': {
      slidesToShow: 2,
      slideGap: '14px',
    },
    '(min-width: 991px)': {
      slidesToShow: 3,
    },
  });

  const productMainButtonAction = document.querySelector('.product-main-reviews__action button');

  if (productMainButtonAction) {
    productMainButtonAction.addEventListener('click', function(event) {
      event.preventDefault();

      let productReviews = document.getElementById('yotpo-reviews-main-widget');
      productReviews.scrollIntoView({ behavior: 'smooth' });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dossier-products-related"]) return;
  try {
    
  const productRelatedSlider = document.querySelector('.product-related__slider');
  new BlazeSlider(productRelatedSlider, {
    all: {
      slidesToShow: 2,
      slidesToScroll: 2,
      loop: false,
    },
    '(min-width: 768px)': {
      slidesToShow: 3,
      slideGap: '15px',
    },
    '(min-width: 991px)': {
      slidesToShow: 4,
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dossier-scents"]) return;
  try {
    
class ScentFamiliesSettings {
  constructor() {
    this.scentBlockClass = '.scent-families__block';
    this.headerGroups = document.querySelectorAll('.shopify-section-group-header-group');
    this.announcementBar = document.querySelector('.announcement-bar-section');
    this.scentToggleBtns = document.querySelectorAll('.scent-families__block__heading');
    this.scentBlocks = document.querySelectorAll(this.scentBlockClass);
    this.scentBlazeSliders = document.querySelectorAll('.scent-families__blaze-slider');
    this.totalHeaderHeight = Array.from(this.headerGroups).reduce((acc, el) => acc + el.offsetHeight, 0);
    this.totalAnnouncementBarHeight = this.announcementBar ? this.announcementBar.offsetHeight : 0;
    
    this.init();
  }

  init() {
    this.initSliders();
    this.initScentBlockFromParam();
    this.setupEventListeners();
    this.openScentFromUrl();
  }
  
  initSliders() {
    this.scentBlazeSliders.forEach(slider => {
      const blazeSlider = new BlazeSlider(slider, {
        all: {
          transitionTimingFunction: 'cubic-bezier(.4,0,.2,1)',
          transitionDuration: 300,
          slidesToShow: 3,
          loop: true
        },
        '(min-width: 991px)': {
          slideGap: '0px'
        },
      });
    });
  }

  openScentFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const scent = params.get('scent');
    if (!scent) return;

    const targetBlock = document.querySelector(`[data-scent="${scent}"]`);
    if (!targetBlock) return;


    this.scentBlocks.forEach(b => {
      if (b.classList.contains('active')) {
        b.classList.replace('active', 'closed');
        setTimeout(() => b.classList.remove('closed'), 500);
      }
    });


    targetBlock.classList.add('active');


    setTimeout(() => {
      let targetPosition = targetBlock.getBoundingClientRect().top + window.scrollY;
      if (window.innerWidth > 900) {
        targetPosition = targetPosition - this.totalHeaderHeight + 20;
      } else {
        targetPosition = targetPosition - this.totalAnnouncementBarHeight;
      }
      window.scrollTo({ top: targetPosition, behavior: "smooth" });
    }, 500);
  }

  setupEventListeners() {
    this.scentBlocks.forEach(block => {
      block.addEventListener('click', (event) => {
        if (block.classList.contains('active')) {
          const btn = event.target.closest('.scent-toggle-button');
          if (!btn) return;

          const currentBlock = btn.closest(this.scentBlockClass);
          if (!currentBlock) return;

          currentBlock.classList.replace('active', 'closed');

          setTimeout(() => {
            currentBlock.classList.remove('closed');
            }, 500);

        } else {
          this.scentBlocks.forEach(b => {
            if (b.classList.contains('active')) {
              b.classList.replace('active', 'closed');
              
              setTimeout(() => {
                b.classList.remove('closed');
              }, 500);
            }
          });

          const currentBlock = event.target.closest(this.scentBlockClass);
          if (!currentBlock) return;
          currentBlock.classList.add('active');

          // Scroll to the active scent block
          this.scrollToScentBlock(currentBlock);

          // Update URL with the scent parameter
          const scent = currentBlock.id.replace('scent-families__', '');
          const url = new URL(window.location);
          url.searchParams.set('scent', scent);
          history.pushState({}, '', url);
        }
      });
    });
  }

  initScentBlockFromParam() {
    const urlParams = new URLSearchParams(window.location.search);
    const scent = urlParams.get('scent');
    const scentBlock = document.querySelector(`#scent-families__${scent}`);

    if (!scentBlock) return;

    scentBlock.classList.add('active');
    this.scrollToScentBlock(scentBlock);
  }

  scrollToScentBlock(scentBlock) {
    setTimeout(() => {
      let targetPosition = scentBlock.getBoundingClientRect().top + window.scrollY;
      if (window.innerWidth > 900) {
        targetPosition = targetPosition - this.totalHeaderHeight + 20;
      } else {
        targetPosition = targetPosition - this.totalAnnouncementBarHeight;
      }
      window.scrollTo({ top: targetPosition, behavior: "smooth" });
    }, 500);
  }
}

document.addEventListener("DOMContentLoaded", () => new ScentFamiliesSettings());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.addEventListener('change', this.setHeaderHeight.bind(this));

      // Temporarily Disabled - Until Further Notice
      // if (this.headerIsAlwaysSticky) {
      //   this.header.classList.add('shopify-section-header-sticky');
      // };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      document.addEventListener('click', (e)=>{
        if(e.target.closest('.bottom-island__menu-btn')){
          this.toggleDrawerMenu();
        }
        if(e.target.closest('.bottom-island__search-btn')){
          setTimeout(() => {
            document.querySelector('header .header__search').open(e)
            document.querySelector('header .header__box--right').classList.add('search-modal--open');
          }, 66);
        }
        if(e.target.closest('.bottom-island__cart-btn')){
          document.querySelector('header #cart-icon-bubble').click();
        }
      });

      //add event listener to header drawer
      this.querySelector('header-drawer').addEventListener('click', (e) => {
        if(e.target.closest('.menu-drawer__close-btn')){
          this.toggleDrawerMenu();
        }
        if(e.target.closest('.menu-drawer__open-search-container')){
          this.toggleDrawerMenu();
        }
      });

      this.togglePopupMenu();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      //console.log('test', `${this.header.offsetHeight}px`,this );
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }

    toggleDrawerMenu(){
      this.header.querySelector('header-drawer summary').click()
    }

    togglePopupMenu() {
      const menuItem = this.header.querySelector('.header__submenu-perfumes .header__menu-item--popup');
      let hideTimeout;

      if (menuItem) {
        const dataPopupId = menuItem.getAttribute('data-popup-id');
        const popup = this.header.querySelector(`#${dataPopupId}`);

        if (popup) {
          function showPopup() {
            clearTimeout(hideTimeout);
            menuItem.classList.add('show');
            popup.classList.add('show');
          }

          function hidePopup() {
            hideTimeout = setTimeout(() => {
              menuItem.classList.remove('show');
              popup.classList.remove('show');
            }, 500);
          }

          menuItem.addEventListener('mouseenter', showPopup);
          menuItem.addEventListener('mouseleave', hidePopup);
          popup.addEventListener('mouseenter', showPopup);
          popup.addEventListener('mouseleave', hidePopup);
        }
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz-page"]) return;
  try {
     
  const startQuizButton = document.querySelector('.image-with-text__content .button--primary');
  startQuizButton.classList.add('quiz-start-btn');
  const buttons = document.querySelectorAll('.js-next-step-btn');
  buttons.forEach(btn => btn.addEventListener('click', nextQuizView));

  function nextQuizView() {
    const view = this.dataset.step;
    const btnData = (this.hasAttribute("data-quizdata")) ? this.dataset.quizdata : null ;
    const quizView = document.querySelector(`.quiz-view.step-${view}`);
    const currentView = this.closest('.quiz-view');

    if(this.classList.contains('js-show-results')) {
      const inputEmail = document.querySelector('#quiz-useremail');
      if(!validateEmail(inputEmail.value)) return
    }

    if(btnData) context.selectedSmells[btnData] = 1;

    currentView.classList.toggle('fade-in');

    setTimeout(function(){
      currentView.style.display = 'none';
      quizView.style.display = 'block';
      quizView.classList.toggle('fade-in');
    }, 700);
  }

  function repositionButton(query) {
		const quizButton = document.querySelector('.quiz-start-btn');
		if (query.matches) { // If media query matches
		quizButton.remove(); // Remove the button from its current location
		document.querySelector('.image-with-text__media-item').appendChild(quizButton); // Append it next to the image
		} else {
		const quizSection = document.querySelector('.image-with-text__content'); // Reference the text section
		quizSection.appendChild(quizButton); // Append the button to the text section
		}
  }

  const mediaQuery = window.matchMedia("(max-width: 767px)");
  repositionButton(mediaQuery);
  mediaQuery.addListener(repositionButton) // Attach listener function on state changes

  startQuizButton.addEventListener('click', function(){
    window.event.preventDefault();
    this.style.display = 'none';

    const startQuizPanel = document.querySelector('.shopify-section.section');
    startQuizPanel.classList.toggle('fade-out');
    setTimeout(function(){ 
      startQuizPanel.style.display = 'none';
      const panel = document.querySelector('.step-00');
      panel.style.display = 'block';
      panel.classList.toggle('fade-in');
    }, 700);
  }, false);


  const productRelatedSlider = document.querySelector('.product-related__slider');
  new BlazeSlider(productRelatedSlider, {
    all: {
      slidesToShow: 2,
      slidesToScroll: 2,
      loop: false,
    },
    '(min-width: 768px)': {
      slidesToShow: 3,
      slideGap: '58px',
    },
    '(min-width: 991px)': {
      slidesToShow: 4,
    },
  });

  } catch(e) { console.error(e); }
})();
})();
